var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "small-12 large-9 column" },
      [
        _vm.addresses.length
          ? [
              _c("VersandaufteilungOverlay", {
                attrs: {
                  belegexemplar: _vm.belegexemplar,
                  isCheckout: _vm.isCheckout,
                  addresses: _vm.addresses,
                  "auflage-zahl": _vm.auflageZahl,
                  productImageUrl: _vm.productImageUrl,
                  productName: _vm.productName,
                },
                on: {
                  closed: function ($event) {
                    return _vm.reloadBasket(...$event)
                  },
                },
              }),
            ]
          : [_c("p", [_vm._v("Loading...")])],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }